import React from 'react'
import { motion } from 'framer-motion'


const GalleryModal = ({onClick, children}) => {
  return (
    <motion.div
     initial={{ scale: 0.5, opacity: 0 }}
     animate={{ scale: 1, opacity: 1 }}
     transition={{ duration: 0.3, ease: "easeIn" }}
     exit={{ opacity: 0.5, transition: { duration: 0.5, ease: "easeOut" } }}
     className='flex flex-col items-center justify-center w-full'>
        
          <div onClick={onClick} className='fixed left-0 top-0 bottom-0 z-50 w-full h-full bg-[#272727] opacity-30'></div>
          
          <div className='fixed top-32 flex items-center justify-center w-[90%] max:h-[65vh] z-50 md:top-20 md:w-[75%] lg:w-[55%] lg:top-40 xl:top-48 xl:w-[45%]'>
                  {children}
          </div>

    </motion.div>
  )
}

export default GalleryModal
